/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AddressDetails__AddressFragmentDoc } from '../../addresses/Addresses.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationDetailsAddressesBox_ViewerOrganisationFragment = { __typename: 'ViewerOrganisation', id: string, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, pickupAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null };

export type OrganisationDetailsAddressesBox_ModifyOrganisationMutationVariables = Types.Exact<{
  input: Types.OrganisationUpdateInput;
}>;


export type OrganisationDetailsAddressesBox_ModifyOrganisationMutation = { updateOrganisation: { __typename: 'OrganisationUpdateResult', organisation: { __typename: 'ViewerOrganisation', id: string, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, pickupAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } } };

export const OrganisationDetailsAddressesBox_ViewerOrganisationFragmentDoc = gql`
    fragment OrganisationDetailsAddressesBox_ViewerOrganisation on ViewerOrganisation {
  id
  billingAddress {
    ...AddressDetails__Address
  }
  branchAddress {
    ...AddressDetails__Address
  }
  pickupAddress {
    ...AddressDetails__Address
  }
}
    ${AddressDetails__AddressFragmentDoc}`;
export const OrganisationDetailsAddressesBox_ModifyOrganisationDocument = gql`
    mutation OrganisationDetailsAddressesBox_ModifyOrganisation($input: OrganisationUpdateInput!) {
  updateOrganisation(input: $input) {
    organisation {
      id
      billingAddress {
        ...AddressDetails__Address
      }
      branchAddress {
        ...AddressDetails__Address
      }
      pickupAddress {
        ...AddressDetails__Address
      }
    }
  }
}
    ${AddressDetails__AddressFragmentDoc}`;
export type OrganisationDetailsAddressesBox_ModifyOrganisationMutationFn = Apollo.MutationFunction<OrganisationDetailsAddressesBox_ModifyOrganisationMutation, OrganisationDetailsAddressesBox_ModifyOrganisationMutationVariables>;

/**
 * __useOrganisationDetailsAddressesBox_ModifyOrganisationMutation__
 *
 * To run a mutation, you first call `useOrganisationDetailsAddressesBox_ModifyOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDetailsAddressesBox_ModifyOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationDetailsAddressesBoxModifyOrganisationMutation, { data, loading, error }] = useOrganisationDetailsAddressesBox_ModifyOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationDetailsAddressesBox_ModifyOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationDetailsAddressesBox_ModifyOrganisationMutation, OrganisationDetailsAddressesBox_ModifyOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationDetailsAddressesBox_ModifyOrganisationMutation, OrganisationDetailsAddressesBox_ModifyOrganisationMutationVariables>(OrganisationDetailsAddressesBox_ModifyOrganisationDocument, options);
      }
export type OrganisationDetailsAddressesBox_ModifyOrganisationMutationHookResult = ReturnType<typeof useOrganisationDetailsAddressesBox_ModifyOrganisationMutation>;
export type OrganisationDetailsAddressesBox_ModifyOrganisationMutationResult = Apollo.MutationResult<OrganisationDetailsAddressesBox_ModifyOrganisationMutation>;
export type OrganisationDetailsAddressesBox_ModifyOrganisationMutationOptions = Apollo.BaseMutationOptions<OrganisationDetailsAddressesBox_ModifyOrganisationMutation, OrganisationDetailsAddressesBox_ModifyOrganisationMutationVariables>;